import { Badge, Heading, Icon, Spacer, Spreader } from '@ui-kit'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'

import styles from './Header.module.scss'

interface HeaderProps {
  name: string
  isCurrentPlan: boolean
  isFreePlan?: boolean
}

export const Header: FC<HeaderProps> = ({
  name,
  isCurrentPlan,
  isFreePlan
}) => {
  const { t } = useTranslation()

  return (
    <Column className={styles.header} vertical='end'>
      <Row>
        {isCurrentPlan || isFreePlan ? (
          <Badge variant='info-filled' weight={600} radius={2}>
            <Icon icon='icon-ok' color='white' size={12} />

            <Spreader spread={5} />

            {t('account.package.current.plan')}
          </Badge>
        ) : null}
      </Row>

      <Spacer space={10} />

      <Heading weight={600}>{name}</Heading>
    </Column>
  )
}

Header.displayName = 'CheckoutPlansPlanPanelsPlanHeader'
